import React from 'react';

import i18n from '../../i18n';

// @mui
import {
    FormControlLabel,
    Checkbox,
} from '@mui/material';

export default class DialogCheckboxField extends React.Component {


    handleCheckboxChanged(event, value) {
        this.props.onChange(event.target.id, value);
    }

    render() {
        // field, value, cache, onChange

        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        const onlyRead = !!this.props.field.onlyRead;

        return (
            <FormControlLabel
                key={this.props.field.label}
                control={
                    <Checkbox
                        disabled={onlyRead}
                        id={this.props.field.id}
                        checked={this.props.value || false}
                        onChange={(event, checked) => this.handleCheckboxChanged(event, checked)}
                    />}
                label={translatedName}
            />
        );
    }
}
